enum StatusFilter {
  ALL = 'all',
  COMPLETED = 'completed',
  NEED_SIGNING = 'need_signing',
  ON_PROCESSING = 'on_processing',
  ON_SIGNING = 'on_signing',
  PROCESSING_FAILED = 'processing_failed',
  REJECTED = 'rejected',
  REQUEST_CANCELLED = 'request_cancelled',
  SIGNING_CANCELLED = 'signing_cancelled',
  WAIT_FOR_SIGNING = 'wait_for_signing',
  SCHEDULED = 'scheduled',
}

export default StatusFilter;
